import { getSSCdnImgUrl } from '@/helpers/cdn';
import { Locale } from '@/helpers/languages';
import { isCdnImg } from './common';

type LocaleGamesMap = {
  [key: string]: string[];
};

const GAMES_BY_LOCALE: LocaleGamesMap = {
  [Locale.ENGLISH_AUSTRALIA]: [
    'voltent/HotSlot777Crown',
    'softswiss/GoldRushWithJohnny',
    'bgmng/ElvisFrogTrueways',
    'redgenn/15DragonPearlsHoldandWin',
    'gamebeat/BuffaloTrail',
    'gamebeat/LordOfTheSeas',
    'netgame/LuckofPandaBonusCombo',
    'popiplay/Moneyfest',
  ],
  [Locale.ENGLISH_CANADA]: [
    'platipus/wildcrowns',
    'softswiss/GoldRushWithJohnny',
    'voltent/HotSlot777Crown',
    'belatra/WildFruitJam',
    'gamebeat/BuffaloTrail',
    'gamebeat/RagingLion',
    'zillion/eaglesGold',
    'mascot/big_win_x25',
  ],
  [Locale.GERMAN]: [
    'voltent/HotSlot777Crown',
    'softswiss/GoldRushWithJohnny',
    'platipus/wildcrowns',
    'n2games/BookOfRaMagic',
    'truelab/RedHot5092',
    'bgmng/HotChilliBells',
    'mancala/HotFruitsonFire',
    'gamzix/3x3HoldTheSpin',
  ],
  [Locale.ENGLISH_NEW_ZEALAND]: [
    'voltent/HotSlot777Crown',
    'softswiss/GoldRushWithJohnny',
    'bgmng/ElvisFrogTrueways',
    'redgenn/15DragonPearlsHoldandWin',
    'gamebeat/BuffaloTrail',
    'gamebeat/LordOfTheSeas',
    'netgame/LuckofPandaBonusCombo',
    'popiplay/Moneyfest',
  ],
  DEFAULT: [
    'voltent/HotSlot777Crown',
    'softswiss/GoldRushWithJohnny',
    'bgmng/ElvisFrogTrueways',
    'redgenn/15DragonPearlsHoldandWin',
    'gamebeat/BuffaloTrail',
    'gamebeat/LordOfTheSeas',
    'netgame/LuckofPandaBonusCombo',
    'popiplay/Moneyfest',
  ],
};

export const getGameImagesByLocale = (locale: string): string[] => {
  const games = GAMES_BY_LOCALE[locale] || GAMES_BY_LOCALE.DEFAULT;

  return games.map((game) =>
    isCdnImg(game) ? game : getSSCdnImgUrl(`${game}`)
  );
};
